export default function sortArrayAlphabeticallyByProperty(array, property) {
    return array.sort(function (a, b) {
        const textA = a[property].toUpperCase();
        const textB = b[property].toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
}
